import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=83a41edc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83a41edc')) {
      api.createRecord('83a41edc', component.options)
    } else {
      api.reload('83a41edc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=83a41edc&", function () {
      api.rerender('83a41edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QK7xqFByOTng/JS/pricehelp.vue"
export default component.exports